// Request util for api call
import request from '~/utils/request';

// Actions Types
import { SET_SENDER_PROFILES_DATA, SET_SENDER_PROFILES_LOADER } from './action-types';

// Utils
import { dateFormat } from '~/utils/date-format';
import { DEFAULT_PAGINATION } from '~/utils/constants';

const fetchSenderProfiles = (payload) => async (dispatch) => {
  try {
    dispatch({ type: SET_SENDER_PROFILES_LOADER, payload: true });

    let url = '/contacts';

    let queryPayload = {
      page: payload?.pagination?.page ? payload.pagination.page : DEFAULT_PAGINATION.page,
      pageSize: payload?.pagination?.pageSize
        ? payload.pagination.pageSize
        : DEFAULT_PAGINATION.pageSize,
      // Fixed filter for Return Address
      isReturnAddress: true,
    };

    if (payload?.search?.length) {
      queryPayload.search = payload.search;
    }

    // Apply advance filters if provided
    if (payload?.applyFilters && payload?.filters) {
      Object.entries(payload.filters).forEach(([key, value]) => {
        if (key === 'lastMailedDate' || key === 'createdAt' || key === 'lastQrScannedDate') {
          // If the value is an object, iterate over its properties
          if (value) {
            let date = Object?.entries(value)
              .map(
                ([nestedKey, nestedValue]) =>
                  `${JSON.stringify(nestedKey)}:${JSON.stringify(nestedValue)}`
              )
              .join(', ');
            queryPayload[key] = `{${date}}`;
          }
        } else if (key === 'tags' && value.length) {
          queryPayload[key] = `[${value}]`;
        } else if (value.length) {
          queryPayload[key] = `${JSON.stringify(value)}`;
        }
      });
    }

    const response = await request.get(url, queryPayload);

    if (response.status === 200) {
      const combinedData = response.data.data.rows.map((contact) => ({
        ...contact,
        id: contact.id,
        senderProfileName: contact.fullName || contact.firstName + ' ' + contact.lastName,
        fullName: contact.fullName || contact.firstName + ' ' + contact.lastName,
        company: contact.company || '-',
        returnAddress: contact.returnAddress || '-',
        phoneNumber: contact.phoneNumber || '-',
        emailAddress: contact.emailAddress || '-',
        createdAt: dateFormat(contact.createdAt),
        lastMailedStatus: contact.lastMailedStatus ? contact.lastMailedStatus : ' -',
        tags: contact.ContactLabels ? contact.ContactLabels.map((label) => label.title) : [],
        checked: false,
      }));

      const senderProfiles = {
        rows: combinedData,
        count: response.data.data.count,
        totalRecordsInDB: response.data.data.totalRecordsInDB,
        to: response.data.data.to,
        from: response.data.data.from,
        currentPage: response.data.data.currentPage,
        lastPage: response.data.data.lastPage,
        perPage: response.data.data.perPage,
      };
      dispatch({ type: SET_SENDER_PROFILES_DATA, payload: senderProfiles });
    }

    return response;
  } catch (error) {
    return error;
  } finally {
    dispatch({ type: SET_SENDER_PROFILES_LOADER, payload: false });
  }
};

const createSenderProfile = (payload) => async () => {
  try {
    // Always set isReturnAddress to true for sender profiles
    const senderProfilePayload = {
      ...payload,
      isReturnAddress: true,
    };
    const senderProfile = await request.post('contacts', senderProfilePayload);
    return senderProfile;
  } catch (error) {
    return error.response;
  }
};

const updateSenderProfile = (payload) => async () => {
  try {
    // Always set isReturnAddress to true for sender profiles
    const senderProfilePayload = {
      ...payload,
      isReturnAddress: true,
    };
    const senderProfile = await request.put(`contacts/${payload.id}`, senderProfilePayload);
    return senderProfile;
  } catch (error) {
    return error.response;
  }
};

const deleteSenderProfile = async (payload) => {
  try {
    const queryPayload = {};

    queryPayload.ids = payload.ids;
    queryPayload.action = payload.action;

    if (payload?.search?.length || payload?.applyFilters) {
      queryPayload.filters = {};
    }
    if (payload?.search?.length) {
      queryPayload.filters.search = payload.search;
    }

    if (payload?.applyFilters) {
      Object.entries(payload.filters).forEach(([key, value]) => {
        if (key === 'lastMailedDate' || key === 'createdAt' || key === 'lastQrScannedDate') {
          // If the value is an object, iterate over its properties
          if (value) {
            queryPayload.filters[key] = value;
          }
        } else if (value.length) {
          queryPayload.filters[key] = value;
        }
      });
    }

    const deleteResponse = await request.post('contacts/bulk-actions', queryPayload);
    return deleteResponse;
  } catch (error) {
    return error.response;
  }
};

export { fetchSenderProfiles, createSenderProfile, updateSenderProfile, deleteSenderProfile };
